/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_All_ToolsInputs */

const en_directory_footer_link_all_tools = /** @type {(inputs: Directory_Footer_Link_All_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All AI tools`)
};

const zh_directory_footer_link_all_tools = /** @type {(inputs: Directory_Footer_Link_All_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部 AI 工具`)
};

/**
* | output |
* | --- |
* | "All AI tools" |
*
* @param {Directory_Footer_Link_All_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_all_tools = /** @type {((inputs?: Directory_Footer_Link_All_ToolsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_All_ToolsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_all_tools(inputs)
	return zh_directory_footer_link_all_tools(inputs)
});
export { directory_footer_link_all_tools as "directory.footer.link_all_tools" }